import SiteHeader from '@/components/feature/SiteHeader';
import SiteFooter from '@/components/feature/SiteFooter';
import SeoHead from '@/components/feature/SeoHead';
import BackToTop from '@/components/feature/BackToTop';
import PageHero from '@/components/feature/PageHero';
import SectionHeading from '@/components/base/SectionHeading';
import FaqAccordion from '@/components/feature/FaqAccordion';
import ContactChannels from '@/pages/contact/components/ContactChannels';
import VerifySection from '@/pages/contact/components/VerifySection';
import TipFormSection from '@/pages/contact/components/TipFormSection';
import InquirySection from '@/pages/contact/components/InquirySection';
import { contactFaqs } from '@/mocks/siteData';

const contactStructuredData = [
  {
    '@context': 'https://schema.org',
    '@type': 'ContactPage',
    name: '联系方式｜深瞳爆料官网',
    url: 'https://shentong-baoliao.com/contact',
    inLanguage: 'zh-CN',
    description:
      '深瞳爆料官网联系方式页面，汇总投稿邮箱、商务合作邮箱、一般咨询邮箱、即时通讯与匿名线索表单。',
  },
  {
    '@context': 'https://schema.org',
    '@type': 'BreadcrumbList',
    itemListElement: [
      { '@type': 'ListItem', position: 1, name: '首页', item: 'https://shentong-baoliao.com/' },
      {
        '@type': 'ListItem',
        position: 2,
        name: '联系方式',
        item: 'https://shentong-baoliao.com/contact',
      },
    ],
  },
  {
    '@context': 'https://schema.org',
    '@type': 'FAQPage',
    mainEntity: contactFaqs.map((faq) => ({
      '@type': 'Question',
      name: faq.q,
      acceptedAnswer: { '@type': 'Answer', text: faq.a },
    })),
  },
];

export default function ContactPage() {
  return (
    <div className="min-h-screen bg-background-50 flex flex-col">
      <SeoHead
        title="联系方式｜投稿邮箱与官方渠道 - 深瞳爆料官网"
        description="深瞳爆料官网联系方式汇总：投稿邮箱 xiansuo@shentong-baoliao.com、商务合作邮箱、一般咨询邮箱、即时通讯通道与匿名线索表单，并说明响应时效与官方账号核实方法。"
        keywords="爆料官网联系方式,投稿邮箱,商务合作邮箱,官方账号核实,匿名投稿"
        path="/contact"
        structuredData={contactStructuredData}
      />
      <SiteHeader />
      <main className="flex-1">
        <PageHero
          kicker="Contact Center"
          title="官方联系方式与投稿入口"
          description="所有通道由平台直接维护，邮箱域名统一为 shentong-baoliao.com。请根据事项类型选择对应通道，敏感线索优先使用加密邮箱。"
          crumbs={[{ label: '首页', to: '/' }, { label: '联系方式' }]}
        />
        <ContactChannels />
        <VerifySection />
        <TipFormSection />
        <InquirySection />

        <section className="bg-background-100 py-14 md:py-24">
          <div className="w-full px-5 md:px-8 lg:px-12">
            <div className="max-w-[1400px] mx-auto grid grid-cols-1 lg:grid-cols-12 gap-10 lg:gap-14">
              <div className="lg:col-span-4">
                <SectionHeading
                  kicker="FAQ"
                  title="联系与投稿常见问题"
                  description="关于官方渠道核实、转载授权与内容更正的常见疑问，都整理在这里。"
                />
              </div>
              <div className="lg:col-span-8">
                <FaqAccordion items={contactFaqs} idPrefix="contact-faq" />
              </div>
            </div>
          </div>
        </section>
      </main>
      <SiteFooter />
      <BackToTop />
    </div>
  );
}